<template>
  <v-card style="height: 100%">
    <v-card-title class="align-center">
      <span>{{ $t("Profil") }}</span>
      <v-spacer />
      <v-btn icon x-small @click="toggleEdit">
        <v-icon color="primary" small>
          {{ isEditing ? mdiClose : mdiPencil }}
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="text--primary">
      <!-- MODE LECTURE (Comme l'affichage de départ) -->
      <div v-if="!isEditing" class="d-flex align-center">
        <span>{{ $t("Profil") }} :</span>
        <div class="text--primary font-weight-semibold ml-2">
          {{ selectedProfileLabel }}
        </div>
      </div>

      <!-- MODE ÉDITION (Comme dans AuthorForm) -->
      <div v-else>
        <v-autocomplete
          v-model="profileValue"
          :items="authorProfiles"
          item-text="label"
          item-value="id"
          :label="$t('Profil')"
          outlined
          dense
          hide-details="auto"
          clearable
        />

        <div class="d-flex justify-end mt-3">
          <v-btn small text class="mr-2" @click="cancelEdit">
            {{ $t("Annuler") }}
          </v-btn>
          <v-btn small color="primary" :loading="loading" @click="saveProfile">
            {{ $t("Enregistrer") }}
          </v-btn>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { ref, watch, computed } from '@vue/composition-api'
import { mdiPencil, mdiClose } from '@mdi/js'
import store from '@/store'

export default {
  name: 'AuthorProfileCard',
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const isEditing = ref(false)
    const loading = ref(false)
    const profileValue = ref(null)

    // Récupération de la liste des profils depuis le Store App (exactement comme le formulaire)
    const authorProfiles = computed(() => store.state.app.authorProfiles || [])

    // Synchronisation avec la valeur reçue
    watch(
      () => props.value,
      newVal => {
        if (newVal) {
          profileValue.value = typeof newVal.profile === 'object' ? newVal.profile?.id : newVal.profile
        }
      },
      { immediate: true, deep: true }
    )

    // Label à afficher en mode lecture
    const selectedProfileLabel = computed(() => {
      if (!props.value || !props.value.profile) return '-'
      if (typeof props.value.profile === 'object') {
        return props.value.profile.label || props.value.profile.name || '-'
      }
      const found = authorProfiles.value.find(p => p.id === props.value.profile || p.label === props.value.profile)
      return found ? found.label : props.value.profile
    })

    const toggleEdit = () => {
      isEditing.value = !isEditing.value
    }

    const cancelEdit = () => {
      isEditing.value = false
      if (props.value) {
        profileValue.value = typeof props.value.profile === 'object' ? props.value.profile?.id : props.value.profile
      }
    }

    const saveProfile = () => {
      loading.value = true

      // Construction du payload identique au formulaire
      const payload = {
        ...props.value,
        profile: profileValue.value,
      }

      const res = store.dispatch('app-author/updateAuthor', payload)

      if (res && typeof res.then === 'function') {
        res
          .then(() => {
            loading.value = false
            isEditing.value = false
            emit('refresh-data')
          })
          .catch(() => {
            loading.value = false
          })
      } else {
        loading.value = false
        isEditing.value = false
        emit('refresh-data')
      }
    }

    return {
      isEditing,
      loading,
      profileValue,
      authorProfiles,
      selectedProfileLabel,
      toggleEdit,
      cancelEdit,
      saveProfile,
      mdiPencil,
      mdiClose,
    }
  },
}
</script>
